var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 12.8333H15.1667V8.16667C15.1667 7.85725 15.0437 7.5605 14.825 7.34171C14.6062 7.12292 14.3094 7 14 7C13.6906 7 13.3938 7.12292 13.175 7.34171C12.9562 7.5605 12.8333 7.85725 12.8333 8.16667V12.8333H8.16667C7.85725 12.8333 7.5605 12.9562 7.34171 13.175C7.12292 13.3938 7 13.6906 7 14C7 14.3094 7.12292 14.6062 7.34171 14.825C7.5605 15.0437 7.85725 15.1667 8.16667 15.1667H12.8333V19.8333C12.8333 20.1428 12.9562 20.4395 13.175 20.6583C13.3938 20.8771 13.6906 21 14 21C14.3094 21 14.6062 20.8771 14.825 20.6583C15.0437 20.4395 15.1667 20.1428 15.1667 19.8333V15.1667H19.8333C20.1428 15.1667 20.4395 15.0437 20.6583 14.825C20.8771 14.6062 21 14.3094 21 14C21 13.6906 20.8771 13.3938 20.6583 13.175C20.4395 12.9562 20.1428 12.8333 19.8333 12.8333Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecPlus);
export default __webpack_public_path__ + "static/media/rec_plus.78df8e455a257efde9711d702a6f0d38.svg";
export { ForwardRef as ReactComponent };